// extracted by mini-css-extract-plugin
export default {"snippet":"CodeSnippet_snippet__t6NlF","code":"CodeSnippet_code__-WOM3","control":"CodeSnippet_control__QSITP","button":"CodeSnippet_button__0EsKg"};